import { SET_SELECTED_LANGUAGE } from './types'
/**
 *
 * @param {string} selectedLanguage // example: 'ru', 'uk'
 */
export const setSelectedLanguage = selectedLanguage => ({
  type: SET_SELECTED_LANGUAGE,
  selectedLanguage
})
